document.addEventListener('DOMContentLoaded', function() {
  validateAccess();
});

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const value = c.substring(nameEQ.length, c.length);
      console.log(value);
      if (value === 'true') return true;
      if (value === 'false') return false;
      return value;
    }
  }
  return null;
}

const validateAccess = function (data=null) {
  if (!data) {
    data = {
      found: getCookie('found'),
      VIP: getCookie('VIP'),
      tags: getCookie('tags'),
    }
    data.VIP = data.VIP=='true';
    data.found = data.found=='true';
  }
  
  if (data.found) {
    if (!data.VIP) {
      console.log('Is not VIP');
      let vipCourseLink = document.querySelector('[href="/community/products/course/6861700ef8459ee6c319035f/68617115f8459ee6c3193c1b"]:not(.updated)');
      if (vipCourseLink) {
        vipCourseLink.classList.add('updated');
        vipCourseLink.setAttribute('href', '#');
        vipCourseLink.querySelector('span span').textContent = 'Unlock';
        let newLink = document.createElement('a');
        newLink.href = '#';
        newLink.textContent = 'Unlock';
        newLink.className = vipCourseLink.className;
        vipCourseLink.parentNode.insertBefore(newLink, vipCourseLink.nextSibling);
        vipCourseLink.remove();
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // make images clickable
  document.addEventListener('click', function(e) {
    if (e.target.matches('.ldt-cr-course-item-content img')) {
      const card = e.target.closest('.ldt-cr-card');
      const link = card.querySelector('.ldt-cr-course-actions a');
      if (link) {
        location.href = link.getAttribute('href');
      }
    }
  });
  
  // Create a MutationObserver configuration
  const config = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  };
  
  function handleChanges() {
    validateAccess();
    
    // the SlimminGood Method
    let backEl = document.querySelector('#slimmingood-app .ldt-cr-course-nav-back:not(.updated)');
    if (backEl) {
      backEl.classList.add('updated');
      backEl.querySelector('span span').textContent = 'The SlimminGood Method';
    }
    
    let backEl2 = document.querySelector('#slimmingood-app .ldt-cr-course-content-nav-content .ldt-cr-card-title span:not(.updated)');
    if (backEl2) {
      backEl2.classList.add('updated');
      backEl2.textContent = 'The SlimminGood Method';
    }
    
    // account link
    let greetingEl = document.querySelector('#slimmingood-app strong.ldt-cr-member-greeting:not(.updated)');
    if (greetingEl) {
      greetingEl.textContent = greetingEl.textContent + ' (account)';
      greetingEl.classList.add('updated');
    }
    
    // text above the courses
    let text = 'Welcome to Your Own SlimminGood Space';
    let coursesListEl = document.querySelector('#slimmingood-app .ldt-cr-course-list:not(.updated)');
    if (coursesListEl) {
      coursesListEl.classList.add('updated');
      const p = document.createElement('p');
      p.style.textAlign = 'center';
      p.textContent = text;
      coursesListEl.parentNode.insertBefore(p, coursesListEl);
    }
    
    // change lessons
    document.querySelectorAll('#slimmingood-app .ldt-cr-nav-section span.ldt-cr-text-xs.ldt-cr-opacity-70:not(.updated)').forEach(function(el) {
      el.classList.add('updated');
      let text = el.textContent.replace('lesson', 'session');
      el.textContent = text;
    });
    
    // change date format
    document.querySelectorAll('.ldt-cr-course-info-detail span.ldt-cr-text-sm:not(.updated), .ldt-cr-course-item-footer-info p:not(.updated)').forEach(function(el) {
      el.classList.add('updated');
      let dateText = el.textContent.split(': ');
      if (dateText.length > 1) {
        let formattedDate = new Date(dateText[1]).toLocaleDateString('en-US');
        el.textContent = dateText[0] + ': ' + formattedDate;
      }
    });
    
    // add unlock link
    document.querySelectorAll('.ldt-cr-course-item-footer .ldt-cr-course-actions:empty:not(.updated)').forEach(function(el) {
      el.classList.add('updated');
      el.innerHTML = '<a class="ldt-cr-inline-block ldt-cr-leading-[normal] ldt-cr-rounded-[32px] ldt-cr-p-2 ldt-cr-px-4 ldt-cr-border ldt-cr-border-primary disabled:ldt-cr-opacity-50 hover:ldt-cr-opacity-90 ldt-cr-bg-primary ldt-cr-text-[var(--ldt-cr-primary-text-color-hex)] hover:ldt-cr-underline ldt-cr-button" href="https://go.drlivingood.com/Slimmingood-lifestyle"><span class="ldt-cr-flex ldt-cr-items-center ldt-cr-gap-1 ldt-cr-w-full">Unlock</span></a>';
      let footer = el.closest('.ldt-cr-course-item-footer-info');
      footer.classList.add('ldt-cr-justify-between');
      const div = document.createElement('div');
      div.className = 'ldt-cr-opacity-95 ldt-cr-course-enrollment-date';
      div.innerHTML = '<p class="ldt-cr-m-0 ldt-cr-text-sm">Upgrade to Join Community</p>';
      footer.prepend(div);
    });
    
    // add logo TODO - update link
    let memberEl = document.querySelector('.ldt-cr-page:not(.updated)');
    if (memberEl) {
      memberEl.classList.add('updated');
      const logoDiv = document.createElement('div');
      logoDiv.className = 'slimmingood-logo';
      logoDiv.innerHTML = '<a href="/community/slimmingood"><img src="https://cdn.shopify.com/s/files/1/0651/4357/0534/files/Dark_background.png?v=1754814875" alt="SlimminGood"></a>';
      memberEl.parentNode.insertBefore(logoDiv, memberEl);
    }
    
    // join VIP elements
    document.querySelectorAll('#slimmingood-app .vip-join:not(.updated)').forEach(function(el) {
      el.classList.add('updated');
      el.style.display = SlimminGoodData.isVip ? 'none' : 'block';
    });
    
    document.querySelectorAll('#slimmingood-app .vip-link:not(.updated)').forEach(function(el) {
      el.classList.add('updated');
      el.style.display = SlimminGoodData.isVip ? 'block' : 'none';
    });
    
    // hide VIP Content Months 7-12
    if (!SlimminGoodData.tags.includes("Dr. Livingood’s VIP Lifestyle 12M") && !SlimminGoodData.tags.includes("Dr. Livingood's VIP Lifestyle 12M")) {
      document.querySelectorAll('#slimmingood-app .ldt-cr-nav-lessons:not(.updated)').forEach(function(el) {
        el.classList.add('updated');
        el.querySelectorAll('li').forEach((li, index) => {
          if (index > 7) li.style.display = 'none';
        });
      });

      // TODO - update link
      const currentPath = '/community/slimmingood/course/66e0a04677dfb51b903d86ab/67571d7f4bffc2e337c135af';
      if (window.location.pathname === currentPath) {
        const continueBtn = document.querySelector('.ldt-cr-button-continue:not(.updated)');
        if (continueBtn) {
          continueBtn.classList.add('updated');
          continueBtn.style.pointerEvents = 'none';
          continueBtn.style.opacity = '0.5';
          continueBtn.disabled = true;
          continueBtn.replaceWith(continueBtn.cloneNode(true));
        }
      } else {
        const updatedBtn = document.querySelector('.ldt-cr-button-continue.updated');
        if (updatedBtn) {
          updatedBtn.classList.remove('updated');
          updatedBtn.style.pointerEvents = '';
          updatedBtn.style.opacity = '';
          updatedBtn.disabled = false;
        }
      }
    }
    
    // remove renew button
    document.querySelectorAll('.ldt-cr-renew-btn:not(.updated)').forEach(function(el) {
      el.classList.add('updated');
      
      const newLink = document.createElement('a');
      // TODO - update link
      newLink.href = 'https://go.drlivingood.com/Slimmingood-lifestyle';
      
      newLink.classList.add(
        'ldt-cr-inline-block',
        'ldt-cr-leading-[normal]',
        'ldt-cr-rounded-[32px]',
        'ldt-cr-p-1',
        'ldt-cr-px-2',
        'sm:ldt-cr-p-2',
        'sm:ldt-cr-px-3',
        'ldt-cr-border',
        'ldt-cr-border-primary',
        'disabled:ldt-cr-opacity-50',
        'hover:ldt-cr-opacity-90',
        'ldt-cr-bg-transparent',
        'ldt-cr-border-0',
        'ldt-cr-text-primary',
        'hover:ldt-cr-underline',
        'ldt-cr-button'
      );
      
      const span = document.createElement('span');
      
      span.classList.add(
        'ldt-cr-flex',
        'ldt-cr-items-center',
        'ldt-cr-gap-1',
        'ldt-cr-w-full'
      );
      
      span.textContent = el.textContent;
      
      newLink.appendChild(span);
      
      el.parentNode.insertBefore(newLink, el);
      
      el.remove();
    });
  }
  
  // Create a MutationObserver instance
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.closest('#slimmingood-app')) {
        handleChanges();
      }
    });
  });
  
  // Start observing the target div
  const targetNode = document.getElementById('slimmingood-app');
  if (targetNode) {
    observer.observe(targetNode, config);
    console.log('Observer started');
  } else {
    console.warn('Target div not found');
  }
});
